

























































import RoundCardPosition from '@/components/RoundCardPosition.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';

const startingCard = 0;
const startingHealth = 150;

@Component({ components: { RoundCardPosition } })
export default class RoundBoard extends Vue {
  activeCard = startingCard as number

  attack = 1 as number

  autoPlaying = false as boolean

  autoPlayingTimer = null as any

  autoPlayTries = 0 as number

  autoPlayWins = 0 as number

  cards = [] as any

  health = startingHealth as number

  height = 600 as number

  width = 600 as number

  constructor() {
    super();
    this.cards = RoundBoard.generateCards();
  }

  get allAreDead(): boolean {
    return !this.cards.find((c: any) => c.health > 0);
  }

  get activeCardIdxs(): number[] {
    const activeCardIdxs = [];
    if (this.activeCard >= 1) {
      activeCardIdxs.push(this.activeCard - 1);
    } else {
      activeCardIdxs.push(this.cards.length - 1);
    }
    activeCardIdxs.push(this.activeCard);
    if (this.activeCard < this.cards.length - 1) {
      activeCardIdxs.push(this.activeCard + 1);
    } else {
      activeCardIdxs.push(0);
    }
    return activeCardIdxs;
  }

  get activeCards(): any[] {
    return this.activeCardIdxs.map(idx => this.cards[idx]);
  }

  get activeCardsAreAllDead(): boolean {
    let foundLiving = false;
    this.activeCards.forEach((card) => {
      if (card.health > 0) {
        foundLiving = true;
      }
    });
    return !foundLiving;
  }

  get livingActiveCards(): any[] {
    return this.activeCards.filter(card => card.health > 0);
  }

  get gameOver(): boolean {
    return this.health <= 0 || this.allAreDead;
  }

  autoPlay(strategy: string) {
    if (this.autoPlaying) {
      return;
    }

    this.autoPlaying = true;
    this.autoPlayTries = 0;
    this.autoPlayWins = 0;

    this.autoPlayingTimer = setInterval(() => {
      if (this.gameOver) {
        if (this.health > 0) {
          this.autoPlayWins += 1;
        }
        this.autoPlayTries += 1;
        this.activeCard = startingCard;
        this.health = startingHealth;
        this.cards = RoundBoard.generateCards();
      }

      switch (strategy) {
        case 'first':
          this.handleClick(this.livingActiveCards[0].idx);
          break;
        case 'last':
          this.handleClick(this.livingActiveCards[this.livingActiveCards.length - 1].idx);
          break;
        case 'random': {
          const randomIdx = Math.floor(Math.random() * this.livingActiveCards.length);
          this.handleClick(this.livingActiveCards[randomIdx].idx);
          break;
        }
        case 'hardest': {
          const winner = this.livingActiveCards.reduce((best, alternative) => {
            const bestRatio = best.attack / best.health;
            const alternativeRatio = alternative.attack / alternative.ratio;
            if (best.attack > alternative.attack) {
              return best;
            }
            if (alternative.attack > best.attack) {
              return alternative;
            }
            if (best.health < alternative.health) {
              return best;
            }
            return alternative;
          });
          this.handleClick(winner.idx);
          break;
        }
        case 'highValue': {
          const winner = this.livingActiveCards.reduce((best, alternative) => {
            const bestRatio = best.attack / best.health;
            const alternativeRatio = alternative.attack / alternative.ratio;
            if (bestRatio > alternativeRatio) {
              return best;
            }
            if (alternativeRatio > bestRatio) {
              return alternative;
            }
            if (best.health < alternative.health) {
              return best;
            }
            return alternative;
          });
          this.handleClick(winner.idx);
          break;
        }
        default:
          this.resetAutoplay();
      }
    }, 20);
  }

  cardClicked(idx: number) {
    if (this.gameOver || this.autoPlaying) {
      return;
    }
    this.handleClick(idx);
  }

  handleClick(idx: number) {
    this.cards[idx].health -= this.attack;

    this.activeCards.forEach((card) => {
      if (card.health > 0) {
        this.health -= card.attack;
      }
    });

    if (this.allAreDead) {
      return;
    }
    do {
      this.activeCard = (this.activeCard + 1) % this.cards.length;
    } while (this.activeCardsAreAllDead);
  }

  isFlipped(idx: number) {
    return this.activeCardIdxs.includes(idx);
  }

  newGame() {
    this.resetAutoplay();
    this.activeCard = startingCard;
    this.health = startingHealth;
    this.cards = RoundBoard.generateCards();
  }

  resetAutoplay() {
    this.autoPlaying = false;
    clearInterval(this.autoPlayingTimer);
    this.autoPlayingTimer = null;
  }

  tryAgain() {
    this.resetAutoplay();
    this.activeCard = startingCard;
    this.health = startingHealth;
    this.cards.forEach((card: any) => {
      card.health = card.originalHealth; // eslint-disable-line no-param-reassign
    });
  }

  private static generateCards() {
    const cards = [];
    for (let i = 0; i < 14; i += 1) {
      const health = Math.ceil(Math.random() * 5);
      cards.push({
        attack: Math.ceil(Math.random() * 5),
        health,
        idx: i,
        originalHealth: health,
      });
    }
    return cards;
  }
}
